import { call, put, takeEvery, all } from 'redux-saga/effects';
import { 
  create as createPurchase,
  addLineItem,
  setShippingOptions,
  recalculateShipping,
} 
  from 'billing/purchases/sagas';
import * as purchaseActions from 'billing/purchases/actions';
import * as productActions from './products/actions';
import * as userActions from 'auth/actions';
import { createAddress, updateAddress } from 'auth/sagas';
import { findProduct } from './products/sagas';
import * as types from './types';

import { error } from 'notifications/actions';
import * as routes from 'app/routes';

export function* fetchProducts({ payload }) {
  const ids = payload.ids;

  let productCallsArray = [];
  for (let i = 0; i < ids.length; i++) {
    productCallsArray.push(
      call(findProduct, productActions.findProduct(ids[i]))
    );
  }

  yield all(productCallsArray);
}

const throwOrderSimError = resp => {
  if (resp && resp.success === false) {
    throw new Error(resp.error);
  }
}

export function* create({ payload }) {
  try {
    const { user, quantity, productAttrs, shippingOptions, shippingDetails } = payload;
    const userId = user.id;
    const address = user.address && user.address[0];
    
    if (address) {
      const addressResp = yield call(updateAddress, userActions.updateAddress({
        id: address.id,
        user_profile: userId,
        full_name: user.first_name + ' ' + user.last_name,
        ...shippingDetails
      }));

      if (addressResp.success === false) {
        throw new Error(addressResp.error);
      }
    }
    else {
      const addressResp = yield call(createAddress, userActions.createAddress({
        user_profile: userId,
        full_name: user.first_name + ' ' + user.last_name,
        ...shippingDetails
      }));

      if (addressResp.success === false) {
        throw new Error(addressResp.error);
      }
    }
    
    const purchaseResp = yield call(createPurchase, purchaseActions.create(userId));

    if (purchaseResp.success === false) {
      throw new Error(purchaseResp.error);
    }
    const purchaseId = purchaseResp.id;

    
    for (let i = 0; i < quantity; i++) {
      const addLineItemResp = yield call(addLineItem, purchaseActions.addLineItem(purchaseId, productAttrs));
      throwOrderSimError(addLineItemResp);
    }
    
    const setShippingResp = yield call(setShippingOptions, purchaseActions.setShippingOptions(purchaseId, shippingOptions));
    throwOrderSimError(setShippingResp);

    const recalculateShippingResp = yield call(recalculateShipping, purchaseActions.recalculateShipping(purchaseId));
    throwOrderSimError(recalculateShippingResp);

    yield put(routes.unpaidPurchase(purchaseId));
  }
  catch (err) {
    yield put(error('orderSim', err.message));
  }
}

export function* watchCreate() {
  yield takeEvery(types.CREATE, create);
}

export function* watchFetchProducts() {
  yield takeEvery(types.FETCH_PRODUCTS, fetchProducts);
}

export function* watchOrderSim() {
  yield all([
    call(watchFetchProducts),
    call(watchCreate),
  ]);
}
